import Gem from './Gem'
import GemGrid from './GemGrid'
import * as GemDetail from './GemDetail'

Gem.Grid = GemGrid
Gem.Detail = GemDetail

export { Gem, GemGrid, GemDetail }

export default Gem
